@if (isLoading) {
  <svg class="pai-button__loader" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <rect class="pai-button__loader-rect-1" width="100%" height="100%" />
    <rect class="pai-button__loader-rect-2" width="100%" height="100%" />
  </svg>
}
<div class="pai-button__inner"><ng-content /></div>
<div class="pai-button__ripple" paiRipple [paiRippleDisabled]="disabled"></div>
